const constants = {
  //AUTH
  SET_AUTH_DATA: "SET_AUTH_DATA",

  //USER DATA
  FETCH_USER_DATA: "FETCH_USER_DATA",
  FETCH_USER_DATA_ERROR: "FETCH_USER_DATA_ERROR",
  FETCHED_USER_DATA: "FETCHED_USER_DATA",

  //BET DATA
  FETCH_BET_DATA: "FETCH_BET_DATA",
  FETCH_BET_DATA_ERROR: "FETCH_BET_DATA_ERROR",
  FETCHED_BET_DATA: "FETCHED_BET_DATA",
  CLEAR_BET_DATA: "CLEAR_BET_DATA",

  //GAME STATE DATA
  SET_COUNTDOWN_STARTED: "SET_COUNTDOWN_STARTED",
  SET_COUNTDOWN_STOPPED: "SET_COUNTDOWN_STOPPED",
  SET_MULTIPLIER_STARTED: "SET_MULTIPLIER_STARTED",
  SET_MULTIPLIER_STOPPED: "SET_MULTIPLIER_STOPPED",
  SET_LOADING_STATE: "SET_LOADING_STATE",

  //PLAYER DATA
  SET_BET_PLACED: "SET_BET_PLACED",
  SET_CASHED_OUT : "SET_CASHED_OUT"
};
export default constants;
